import { useMemo } from "react";

import {
  FREE_TRIAL_PROMOTION,
  SINGLE_USE_DURATION,
} from "../services/api/subscription/constants";
import {
  IFreeDetail,
  ISpSubscriptionPromotion,
} from "../services/api/subscription/types";

export function useIsShowPromotion(promotion?: ISpSubscriptionPromotion) {
  return useMemo(() => {
    if (promotion?.detail.kind === FREE_TRIAL_PROMOTION) {
      return !(promotion?.detail as IFreeDetail).is_trial_expired;
    }

    return (
      !!promotion &&
      promotion.detail.duration !== SINGLE_USE_DURATION &&
      promotion.is_active
    );
  }, [promotion]);
}
